import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { TranslateModule } from '@ngx-translate/core';
import { CustomisableVariables } from '@shared/models/customisable-variables';
import { CustomisableVariablesService } from '@shared/services/customisable-variables.service';
import { ProcessResultComponent } from '@shared/shared/components/process-result/process-result.component';
import { AccessibleClickDirective } from '@shared/shared/directives/accessible-click.directive';
import { Observable } from 'rxjs';

@Component({
  selector: 'ten-member-registration-result',
  templateUrl: './member-registration-result.component.html',
  styleUrls: ['./member-registration-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ProcessResultComponent, NgIf, AsyncPipe, TranslateModule, MatIconModule, AccessibleClickDirective],
})
export class MemberRegistrationResultComponent {
  public variables$: Observable<CustomisableVariables>;
  public result: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<MemberRegistrationResultComponent>,
    private customisableVariablesService: CustomisableVariablesService
  ) {
    this.variables$ = this.customisableVariablesService.variables;
    this.result = data ? 'success' : 'failure';
  }

  public close() {
    this.dialogRef.close();
  }
}
